import { LogoFull } from "./Logo";
import { scrollToId } from "@/data/content";

const NAV = [
  { label: "Products", id: "products" },
  { label: "Benefits", id: "benefits" },
  { label: "Why Doodles?", id: "why-poodles" },
  { label: "Dosing", id: "dosing" },
  { label: "Quality", id: "quality" },
];

export const Footer = () => (
  <footer data-testid="cbdoodle-footer-container" className="bg-[#203028] px-5 pb-10 pt-16 sm:px-8">
    <div className="mx-auto max-w-7xl">
      <div className="grid gap-10 border-b border-white/10 pb-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="w-fit overflow-hidden rounded-2xl">
            <LogoFull variant="dark" className="h-28 w-auto" />
          </div>
          <p className="mt-5 max-w-sm font-sans text-sm leading-relaxed text-[#9fb0a7]">
            A premium CBD concept for the golden years — helping senior poodles and aging dogs stay comfortable,
            mobile, and calm. Formulated with aging dogs in mind.
          </p>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#E7C489]">Explore</h4>
          <ul className="mt-4 space-y-2.5">
            {NAV.map((l) => (
              <li key={l.id}>
                <button onClick={() => scrollToId(l.id)} className="font-sans text-sm text-[#C9D3CC] transition-colors hover:text-white">
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <h4 className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#E7C489]">Get Early Access</h4>
          <p className="mt-4 font-sans text-sm leading-relaxed text-[#9fb0a7]">
            Join the waitlist to help shape the final formula and unlock founding-member perks.
          </p>
          <button
            onClick={() => scrollToId("waitlist")}
            className="mt-4 rounded-full bg-[#C58F3B] px-6 py-3 font-sans text-sm font-medium text-white transition-colors hover:bg-[#B07D2B]"
          >
            Join the Waitlist
          </button>
        </div>
      </div>

      <div className="pt-8">
        <p data-testid="cbdoodle-fda-disclaimer" className="mx-auto max-w-4xl text-center font-sans text-xs leading-relaxed text-[#8a9992]">
          CBDoodle is a concept showcase; the exact formula will be finalized later. These statements have not
          been evaluated by the FDA. CBDoodle is not intended to diagnose, treat, cure, or prevent any disease.
          Always consult your veterinarian before starting any new supplement, especially for senior dogs or
          pets on other medications.
        </p>
        <div className="mt-6 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row">
          <span className="font-sans text-xs text-[#8a9992]">© {new Date().getFullYear()} CBDoodle. All rights reserved.</span>
          <span className="font-sans text-xs text-[#8a9992]">Made with care for golden-years poodles 🐩</span>
        </div>
      </div>
    </div>
  </footer>
);
